(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veoveo-complementos"]) return;
  try {
    
  (() => {
    const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const kind = product => {
      const t = normalize(product.title);
      if (/leotardo/.test(t)) return 'tights';
      if (/calcetin/.test(t)) return 'socks';
      if (/lazo de pelo|lazo de cuadros|^lazo |diadema|coletero/.test(t)) return 'hair';
      if (/falda|vestido|ranita|culetin|pichi|short/.test(t)) return 'dress';
      if (/pantalon|chandal/.test(t)) return 'pants';
      if (/body|bogy|blusa|camisa|camiseta|jersey/.test(t)) return 'top';
      if (/conjunto|pelele/.test(t)) return 'outfit';
      if (/chaqueta|abrigo|chaleco/.test(t)) return 'coat';
      if (/babero|pechito|gasa|mordedor|chupete|cuchara/.test(t)) return 'baby';
      return 'other';
    };
    const color = value => {
      const t = normalize(value);
      return ['blanco','nata','crudo','natural','arena','beige','lino','turron','vison','topo','piedra','marron','negro','antracita','gris','rosa','malva','maquillaje','granate','rojo','azul','marino','celeste','verde','amarillo','coral','violeta','morado'].filter(x => new RegExp('(^|[^a-z])'+x+'([^a-z]|$)').test(t));
    };
    const neutrals = new Set(['blanco','nata','crudo','natural','arena','beige','lino','piedra','gris']);
    const pairs = {
      'falda-pantalon-atari-denim': 'blusa-atari-natural',
      'blusa-atari-natural': 'falda-pantalon-atari-denim',
      'falda-pantalon-atari-malva': 'blusa-atari-arena',
      'blusa-atari-arena': 'falda-pantalon-atari-malva'
    };
    const age = (product, variant) => {
      const idx = (product.options || []).findIndex(x => /talla|size|edad/i.test(x));
      const t = normalize(variant?.options?.[idx] || variant?.title);
      if (product.handle?.includes('leotardos-condor')) return ({'000':[0,3],'00':[3,6],'0':[6,12],'2':[12,24]})[t] || null;
      if (/unica|default/.test(t)) return null;
      const match = t.match(/(\d+)\s*(?:a|-|–)?\s*(\d+)?\s*(mes|ano)/);
      if (!match) return null;
      const factor = match[3] === 'ano' ? 12 : 1;
      return [Number(match[1])*factor,Number(match[2] || match[1])*factor];
    };
    const genders = product => {
      const tags = (product.tags || []).map(normalize);
      return { girl: tags.includes('nina'), boy: tags.includes('nino') };
    };
    function recommend(source, selected, products, cart) {
      const sk = kind(source), sa = age(source, selected), sg = genders(source);
      const sourceColors = color(source.title+' '+(selected?.title || ''));
      const inCart = new Set(cart.items.map(item=>String(item.product_id)));
      const allowed = {
        dress:['tights','socks','hair'], pants:['socks'], top:['socks','tights'],
        outfit:['tights','socks','hair','baby'], coat:['socks','tights'],
        tights:['dress','outfit','hair'], socks:['pants','dress','outfit'],
        hair:['dress','outfit','tights'], baby:['baby'], other:[]
      }[sk];
      const ranked = [];
      for (const p of products) {
        if (String(p.id)===String(source.id) || inCart.has(String(p.id))) continue;
        const pk=kind(p), exact=pairs[source.handle]===p.handle, pg=genders(p);
        if (!exact && !allowed.includes(pk)) continue;
        if (pk==='socks' && /disney|lilo|stitch|toy story|buzz|alien|mickey|minnie/.test(normalize(p.title+' '+p.variants.map(v=>v.title).join(' '))) && !/disney|lilo|stitch|toy story|mickey|minnie/.test(normalize(source.title))) continue;
        if (sg.boy && !sg.girl && (pk==='hair' || (pg.girl && !pg.boy))) continue;
        if (sg.girl && !sg.boy && pg.boy && !pg.girl) continue;
        if (pk==='baby' && (!sa || sa[0]>12)) continue;
        if (sk==='baby' && pk==='baby' && normalize(p.type)===normalize(source.type)) continue;
        const variants=p.variants.filter(v=>{
          const va=age(p,v);
          if (sa && va && (va[1]<sa[0] || va[0]>sa[1])) return false;
          if (sa && !va && p.handle.includes('leotardos-condor')) {
            if (sa[1]<24) return false;
            if (sa[0]>=24 && ['000','00','0','2'].includes(v.title)) return false;
          }
          if (sa && !va && /^\d+/.test(v.title) && /mes|ano/.test(normalize(source.title)) && pk==='socks') return false;
          const vc=color(v.title+' '+p.title);
          return exact || !vc.length || vc.some(c=>sourceColors.includes(c) || neutrals.has(c));
        });
        if (!variants.length) continue;
        const pc=color(p.title);
        let score=exact?200:30;
        if (pc.some(c=>sourceColors.includes(c))) score+=35;
        if (pc.some(c=>neutrals.has(c))) score+=15;
        if (pk==='tights' && ['dress','outfit'].includes(sk)) score+=15;
        if (p.handle.includes('condor')) score+=8;
        if (p.handle.includes('nata-202')) score+=2;
        ranked.push({product:p,variants,kind:pk,score});
      }
      ranked.sort((a,b)=>b.score-a.score || a.product.title.localeCompare(b.product.title));
      const chosen=[], used=new Set();
      for (const row of ranked) {
        if (used.has(row.kind)) continue;
        chosen.push(row);used.add(row.kind);
        if (chosen.length===3) break;
      }
      return chosen;
    }
    class VeoveoComplementos extends HTMLElement {
      connectedCallback() {
        if(this.initialized) return;
        this.initialized=true;
        this.dialog=this.querySelector('dialog');
        this.grid=this.querySelector('[data-products]');
        this.status=this.querySelector('[data-status]');
        this.labels=JSON.parse(this.querySelector('[data-labels]').textContent);
        this.currency=this.dataset.currency || 'EUR';
        this.root=window.Shopify?.routes?.root || this.dataset.root || '/';
        this.root=this.root.replace(/\/?$/, '/');
        this.querySelectorAll('[data-close]').forEach(b=>b.addEventListener('click',()=>this.dialog.close()));
        this.dialog.addEventListener('click',e=>{ if(e.target===this.dialog) { const r=this.dialog.getBoundingClientRect(); if(e.clientX<r.left || e.clientX>r.right || e.clientY<r.top || e.clientY>r.bottom) this.dialog.close(); }});
        this.dialog.addEventListener('close',()=>{ this.ticket++;document.body.classList.remove('vv-complements-open');this.trigger?.focus?.(); });
        window.veoveoCrossSell=this;
        this.ticket=0;
      }
      money(value) {return new Intl.NumberFormat(this.dataset.locale || 'es-ES',{style:'currency',currency:this.currency}).format(value/100);}
      url(path) {
        const u=new URL(path,location.origin);
        const preview=new URL(location.href).searchParams.get('preview_theme_id');
        if(preview)u.searchParams.set('preview_theme_id',preview);
        return u;
      }
      async fetchJson(path,options={}) {
        const r=await fetch(this.url(path),{...options,signal:options.signal || AbortSignal.timeout(6500)});
        const data=await r.json();
        if(!r.ok || data.status)throw new Error(data.description || this.labels.error);
        return data;
      }
      async catalog() {
        if(this.catalogData && Date.now()-this.catalogTime<30000)return this.catalogData;
        const r=await fetch(this.url(this.root+'?section_id=veoveo-complementos-data'),{signal:AbortSignal.timeout(5000)});
        if(!r.ok)throw new Error('catalog');
        const doc=new DOMParser().parseFromString(await r.text(),'text/html');
        const products=JSON.parse(doc.querySelector('[data-veoveo-catalog]').textContent).products;
        this.catalogData=products;this.catalogTime=Date.now();return products;
      }
      show(added,cartElement) {
        if(!this.dialog?.showModal || this.dialog.open || !added)return false;
        const item=added.items?.[0] || added;
        if(!item.product_id)return false;
        this.cartElement=cartElement;this.trigger=cartElement.activeElement || document.activeElement;
        cartElement.close();
        this.querySelector('#vv-complements-added').textContent=item.product_title || item.title || '';
        this.grid.replaceChildren();this.status.hidden=false;this.status.textContent=this.labels.loading;
        this.dialog.showModal();document.body.classList.add('vv-complements-open');
        const ticket=++this.ticket;
        this.load(item,ticket).catch(()=>{if(this.ticket===ticket && this.dialog.open){this.dialog.close();cartElement.open();}});
        return true;
      }
      async load(added,ticket) {
        const [products,cart]=await Promise.all([this.catalog(),this.fetchJson(this.root+'cart.js')]);
        if(ticket!==this.ticket || !this.dialog.open)return;
        this.currency=cart.currency || this.currency;
        let source=products.find(p=>String(p.id)===String(added.product_id));
        if(!source) {
          const handle=(added.handle || (added.url || '').split('/products/')[1]?.split('?')[0]);
          if(handle)source=await this.fetchJson(this.root+'products/'+encodeURIComponent(handle)+'.js');
        }
        if(!source)throw new Error('source');
        source.options=(source.options || []).map(o=>typeof o==='string'?o:o.name);
        const selected=source.variants.find(v=>String(v.id)===String(added.variant_id || added.id)) || {title:added.variant_title,options:added.options_with_values?.map(o=>o.value)};
        const results=recommend(source,selected,products,cart);
        if(ticket!==this.ticket || !this.dialog.open)return;
        if(!results.length){this.dialog.close();this.cartElement.open();return;}
        this.dialog.style.setProperty('--vv-popup-width', ({1:500,2:760,3:960})[results.length]+'px');
        this.grid.style.setProperty('--vv-columns', String(results.length));
        this.grid.replaceChildren(...results.map(row=>this.card(row)));
        this.status.hidden=true;
      }
      card({product:p,variants}) {
        const card=document.createElement('article');card.className='vv-complements__card';
        const link=document.createElement('a');link.href=this.url(p.url);link.className='vv-complements__image';link.setAttribute('aria-label',this.labels.view+' '+p.title);
        const img=document.createElement('img');img.src=variants[0].image || p.image;img.alt=p.title;img.width=210;img.height=250;img.loading='lazy';link.append(img);
        const heading=document.createElement('h3');const title=document.createElement('a');title.href=this.url(p.url);title.textContent=p.title;heading.append(title);
        const price=document.createElement('p');price.className='vv-complements__price';
        const prices=variants.map(v=>v.price);price.textContent=(new Set(prices).size>1?this.labels.from+' ':'')+this.money(Math.min(...prices));
        const select=document.createElement('select');select.setAttribute('aria-label',this.labels.options+' '+p.title);
        const single=variants.length===1 && /default title|unica/i.test(normalize(variants[0].title));
        if(!single){const placeholder=new Option(this.labels.choose,'');placeholder.disabled=true;placeholder.selected=true;select.add(placeholder);}
        for(const v of variants)select.add(new Option(v.title+' · '+this.money(v.price),String(v.id)));
        if(single)select.hidden=true;
        const button=document.createElement('button');button.type='button';button.className='vv-complements__add';button.textContent=this.labels.add;button.disabled=!single;
        select.addEventListener('change',()=>{const v=variants.find(v=>String(v.id)===select.value);button.disabled=!v;price.textContent=this.money(v.price);img.src=v.image || p.image;});
        button.addEventListener('click',()=>this.add(select,button,p));
        card.append(link,heading,price,select,button);return card;
      }
      async add(select,button,product) {
        if(button.disabled || !select.value)return;
        button.disabled=true;select.disabled=true;button.textContent=this.labels.adding;
        let applied=false;
        try {
          const sections=this.cartElement.getSectionsToRender().map(s=>s.id);
          const result=await this.fetchJson(this.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:Number(select.value),quantity:1,sections,sections_url:location.pathname+location.search})});
          applied=true;
          this.cartElement.renderContents(result,{suppressOpen:true});
          this.catalogData=null;
          button.textContent=this.labels.added;
          this.status.hidden=false;this.status.textContent=this.labels.added+': '+product.title;
          const cart=await this.fetchJson(this.root+'cart.js');
          if(typeof publish==='function')publish(PUB_SUB_EVENTS.cartUpdate,{source:'veoveo-cross-sell',productVariantId:select.value,cartData:cart});
        } catch(error) {
          this.status.hidden=false;this.status.textContent=applied?this.labels.added+': '+product.title:(error.message || this.labels.error);
          button.textContent=applied?this.labels.added:this.labels.add;
          if(!applied){button.disabled=false;select.disabled=false;}
        }
      }
    }
    if(!customElements.get('veoveo-complementos'))customElements.define('veoveo-complementos',VeoveoComplementos);
  })();

  } catch(e) { console.error(e); }
})();
})();
